<template>
  <DBox
    :id="'cmp-distribution-accounts-account_sidewindow-statement_history_list'"
    :addButton="false"
    :addLink="true"
    :rightMenu="[
      {
        text: $t('account_on_multiple_invoice'),
        value: 'account_on_multiple_invoice',
        type: isEnabled ? '' : ' disabled',
        isLoading: isEnabled ? false : true,
      },
      {
        text: $t('invoice_statement'),
        value: 'invoice_statement',
        type: isEnabled ? '' : ' disabled',
      },
    ]"
    @menuClick="onRightMenuClick"
    :addLinkLabel="`${$t('add_new')} ${$t('')}`"
    @add_click="onAddClick"
  >
    <NTable
      :id="'distribution-accounts-account_sidewindow-current_statement_list'"
      class="dbox1"
      :headers="headers"
      :items="list"
      :config="tableConfig"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('exclude')">
            <div class="ut-flex">
              <div
                class="dt-checkbox v2 s1"
                :class="{
                  disabled: item.all_lines_assigned == '0' ? 'disabled' : false,
                }"
                style="margin: auto 0px auto 0px"
              >
                <input
                  class="disabled"
                  type="checkbox"
                  :disabled="
                    item.all_lines_assigned == '0' ? 'disabled' : false
                  "
                  :checked="selectedStatementIDs.has(item.statement_id) == true"
                  @click="(e) => onCheckBoxChange(e, item)"
                />
                <div class="checkmark"></div>
              </div>
              <div style="margin: auto 0px auto 10px">
                <span
                  v-if="item.all_lines_assigned && item.all_lines_assigned == 1"
                >
                  {{ $t('ready') }}
                </span>
                <span v-else style="min-width: 32px; display: block"> </span>
              </div>
              <div
                class="ut-link ut-text-accent5 txtov"
                style="margin: auto 0px auto 10px; min-width: 115px"
                @click="onClickAccount(item)"
              >
                {{ item["description"] }}
              </div>
            </div>
          </td>
          <!-- <td  v-bind="tdcon('description')">
            <span @click="onDesClick(item)" class="ut-link ut-text-accent5"> {{account_name}}</span>
          </td> -->

          <td v-bind="tdcon('period')">
            <span> {{ item["statement_period_txt"] }}</span>
          </td>
          <td v-bind="tdcon('year')">
            <span>{{ item["statement_year"] }}</span>
          </td>

          <td v-bind="tdcon('type')">
            <span>{{ item["digital_physical"] }}</span>
          </td>
          <td v-bind="tdcon('currency')">
            <span>{{ item["currency"] }}</span>
          </td>

          <!-- <td v-bind="tdcon('country')">
            <span>{{ item["fix_country"] }}</span>
          </td> -->
          <td v-bind="tdcon('invoice_contact')">
            <span class="txtov">{{ item["invoice_contact"] }}</span>
          </td>

          <td v-bind="tdcon('income')">
            <span> {{ item["import_amount"] }}</span>
          </td>
          <td v-bind="tdcon('difference')">
            <span>
              <!-- {{ parseFloat(item["rounding_difference"]).toFixed(2) }} -->
            </span>
          </td>

          <td v-bind="tdcon('total')">
            <span>{{ item["statement_amount"] }}</span>
          </td>

          <td v-bind="tdcon('options')" class="print">
            <img
              src="static/icons/delete.svg"
              class="dt-icon v5"
              @click="(e) => onDeleteCurrentStatement(item)"
              alt="Delete Contact"
              title="Delete Contact"
            />
          </td>
        </tr>
      </template>
    </NTable>
    <!-- <div class="dbox-title-bar--options">
      <img @click="addCurrentStatementClick" src="static/icons/add-icon.svg" class="dt-icon v4" alt />
    </div>
    <template v-if="addCurrentStatementModalContainer">
      <v-dialog persistent width="800" v-model="addCurrentStatementModal">
        <AddCurrentStatement @added="onCurrentStatementAdded" @cancelled="onAddCurrentStatementCancelled" />
      </v-dialog>
    </template> -->
  </DBox>
</template>

<script>
import { DistributionStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters } from "vuex";
import * as ActionTypes from "../../store/types";
import Dropdown from "../../../../plugins/dropdown/dropdown";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import TextInput from "../../../../plugins/text-field/text-input";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import AddCurrentStatement from "./add-current-statement";
import { addRemoveSet, wait } from "../../../../utility";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import { async } from "ramda-adjunct";
import { distributionStatementListLDTRoutes } from "../../router/routes";
import { boolean } from "sanctuary";

export default {
  components: {
    NTable,
    TextInput,
    AddCurrentStatement,
  },
  props: {
    selectedAccountsDetails: {
      type: Object,
    },
    isEnabled: {
      type: boolean,
    },
  },
  mounted: async function () {
    // console.log("STATAT",this.statement_id)
    if (this.statement_id != "") {
      // If all lines are assigned, then we can select the statement
      await this.assignSelectedStatementIdRepeatedly();

      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          select_statement_id: undefined,
        },
      });
    }
  },
  data: function () {
    return {
      selectedStatementIDs: new Set(),
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        footer: false,
        key: "currentStatementList",
      }),
      addCurrentStatementModalContainer: false,
    };
  },
  computed: {
    statement_id: function () {
      return this.$route.query.select_statement_id || "";
    },
    list: function () {
      return this.selectedAccountsDetails?.current_statements;
    },
    account_name: function () {
      return this.selectedAccountsDetails?.account?.account_name || "";
    },
    headers: function () {
      return [
        createTableHeader("exclude", { text: "Current Statements", minw: 400 }),
        //createTableHeader("description",{ text:'Statements' }),
        createTableHeader("period", { mw: 55, ta: "left" }),
        createTableHeader("year", { mw: 45, ta: "left" }),
        createTableHeader("type", { mw: 100, ta: "left" }),
        createTableHeader("currency", { mw: 65, ta: "left" }),
        //createTableHeader("country", { ta: "left" ,mw:60}),
        createTableHeader("invoice_contact", { minw: 200, ta: "left" }),
        createTableHeader("income", { ta: "right",minw:85,mw:85 }),
        createTableHeader("difference", { ta: "right",minw:75,mw:75 }),
        createTableHeader("total", { ta: "right",minw:85,mw:85 }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
  },
  //mixins: [createModalMixin("addCurrentStatement")],
  methods: {
    async assignSelectedStatementId() {
      let checkerObject = this.list?.find(
        (e) => e.statement_id == +this.statement_id
      );

      if (checkerObject) {
        if (checkerObject.all_lines_assigned == 1) {
          this.selectedStatementIDs = addRemoveSet(
            true,
            this.selectedStatementIDs,
            +this.statement_id
          );
        }
        return true;
      }
      return false;
    },

    async assignSelectedStatementIdRepeatedly() {
      let found = false;
      for (let i = 0; i < 30; i++) {
        found = await this.assignSelectedStatementId();
        if (found) {
          this.$router.push({
            ...this.$route,
            query: {
              ...this.$route.query,
              select_statement_id: undefined,
            },
          });
          break;
        }
        if (!found && this.list?.length > 0) {
          this.$router.push({
            ...this.$route,
            query: {
              ...this.$route.query,
              select_statement_id: undefined,
            },
          });
          break;
        }
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    },
    onAddCurrentStatementCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          account_id: undefined,
          external_table: undefined,
        },
      });
    },
    onCurrentStatementAdded: function (statements) {
      this[ActionTypes.CURRENT_STATEMENT.SET.ALL](statements);
      this.onAddCurrentStatementCancelled();
    },
    onDeleteCurrentStatement: function (item) {
      this.$emit("delete", item);

      //this[ActionTypes.CURRENT_STATEMENT.DELETE.SINGLE]({ statement_id: item.statement_id });
    },
    onRightMenuClick: function (e) {
      console.log(":::::::", this.selectedStatementIDs, e);
      if (this.selectedStatementIDs.size > 0) {
        if (e === "invoice_statement") {
          this.$emit("setStatementsIvoice", this.selectedStatementIDs);
        } else if (this.isEnabled) {
          this.$emit("setAccounOnMultipleInvoice", this.selectedStatementIDs);
        }
      }
    },
    onAddClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "new_current_statement",
          account_id: this.selectedAccountsDetails?.account?.account_id,
        },
      });
    },

    onCheckBoxChange: async function (e, item) {
      console.log("OUTSIDE", item.all_lines_assigned == 0);

      if (item.all_lines_assigned == 0) {
        e.preventDefault();

        const confirmationResult = await ConfirmationService.createP({
          body: this.$t(
            "This statement is not ready yet. Please check for missing matchings."
          ),
          results: [
            createConfirmResult({
              value: "ok",
              text: "OK",
              classes: ["v1 s7"],
            }),
          ],
        });

        return;
      }

      let addToSet = false;

      if (this.selectedStatementIDs.size > 0) {
        const checkerObject = this.list.find(
          (e) => e.statement_id == [...this.selectedStatementIDs][0]
        );

        if (checkerObject) {
          addToSet =
            checkerObject.currency_id === item.currency_id &&
            checkerObject.invoice_contact === item.invoice_contact &&
            checkerObject.invoice_project_id === item.invoice_project_id;
          console.log(addToSet, "add yt set");
        }
        console.log('checkerObject', checkerObject);
      } 
      
      else {
        addToSet = true;
      }

      if (addToSet) {
        this.selectedStatementIDs = addRemoveSet(
          e.target.checked,
          this.selectedStatementIDs,
          item.statement_id
        );
        console.log(addToSet, "sssssssssss");
      } 
      
      else {
        e.preventDefault();
        const confirmationResult = await ConfirmationService.createP({
          body: this.$t(
            "Either the currency, the invoice project or the invoice contact does not match your selection."
          ),
          results: [
            createConfirmResult({
              value: "ok",
              text: "OK",
              classes: ["v1 s7"],
            }),
          ],
        });
      }

      console.log(
        this.selectedStatementIDs,
        "::::::::::::::::::::::::::::::::::::::::::::"
      );
    },

    onDesClick: function (item) {
      console.log(item, ":::::::::");
      this.$router.push({
        name: distributionStatementListLDTRoutes.names.tab,
        params: {
          statement_id: item.statement_id,
          tab: "summary",
        },
      });
      //distributionStatementListLDTRoutes
    },
    onClickAccount: function (item) {
      console.log(this.selectedAccountsDetails?.account);

      const { statement_id, all_lines_assigned } = item;
      console.log(item, statement_id);
      this.$router.push({
        name: distributionStatementListLDTRoutes.names.tab,
        params: {
          statement_id: item.statement_id,
          tab:
            all_lines_assigned && all_lines_assigned > 0
              ? "import_result"
              : "import_matching",
        },
      });
      distributionStatementListLDTRoutes;
      //this.$router.push("/main/distribution/imports");
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-accounts-account_sidewindow-current_statement_list {
  .current-statement-list {
    --ntable-height: 320px !important;
    th:nth-child(2),
    th:nth-child(8) {
      min-width: max-content;
    }
    td:nth-child(2),
    th:nth-child(8) {
      min-width: max-content;
    }
    tr {
      padding-left: 5px;
      td {
        margin-right: 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: flex;
      }
    }
  }
}
</style>